var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMonthToDate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: 270.256,
    viewBox: "0 0 332 270.256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3118",
    "data-name": "Group 3118",
    transform: "translate(-91 -2729.744)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Last_Update:",
    "data-name": "Last Update:",
    transform: "translate(337 2743.35)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -55.879,
    y: 0
  }, "Last Update:")), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1562",
    "data-name": "Rectangle 1562",
    width: 161,
    height: 239,
    transform: "translate(91 2761)",
    fill: "#f8f8f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1563",
    "data-name": "Rectangle 1563",
    width: 161,
    height: 239,
    transform: "translate(262 2761)",
    fill: "#f8f8f9"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Ad_Spend_Views_Clicks_Click_Through_Rate_Calls_Click_to_Call_Call_Conversion_New_Patients",
    "data-name": "Ad Spend Views Clicks Click Through Rate Calls Click to Call % Call Conversion % New Patients",
    transform: "translate(237 2801.744)",
    fill: "#329998",
    fontSize: 12,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -51.164,
    y: 0
  }, "Ad Spend"), /*#__PURE__*/React.createElement("tspan", {
    x: -32.109,
    y: 26
  }, "Views"), /*#__PURE__*/React.createElement("tspan", {
    x: -32.186,
    y: 52
  }, "Clicks"), /*#__PURE__*/React.createElement("tspan", {
    x: -100.412,
    y: 78
  }, "Click Through Rate"), /*#__PURE__*/React.createElement("tspan", {
    x: -26.35,
    y: 104
  }, "Calls"), /*#__PURE__*/React.createElement("tspan", {
    x: -74.508,
    y: 130
  }, "Click to Call %"), /*#__PURE__*/React.createElement("tspan", {
    x: -94.963,
    y: 156
  }, "Call Conversion %"), /*#__PURE__*/React.createElement("tspan", {
    x: -70.852,
    y: 182
  }, "New Patients")), /*#__PURE__*/React.createElement("text", {
    id: "_125_270_24_9_7_29_29_2",
    "data-name": "$125 270 24 9% 7 29% 29% 2",
    transform: "translate(342 2801.744)",
    fill: "#329998",
    fontSize: 14,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -15.723,
    y: 0
  }, "$125"), /*#__PURE__*/React.createElement("tspan", {
    x: -11.792,
    y: 26
  }, "270"), /*#__PURE__*/React.createElement("tspan", {
    x: -7.861,
    y: 52
  }, "24"), /*#__PURE__*/React.createElement("tspan", {
    x: -9.058,
    y: 78
  }, "9%"), /*#__PURE__*/React.createElement("tspan", {
    x: -3.931,
    y: 104
  }, "7"), /*#__PURE__*/React.createElement("tspan", {
    x: -12.988,
    y: 130
  }, "29%"), /*#__PURE__*/React.createElement("tspan", {
    x: -12.988,
    y: 156
  }, "29%"), /*#__PURE__*/React.createElement("tspan", {
    x: -3.931,
    y: 182
  }, "2")), /*#__PURE__*/React.createElement("text", {
    id: "Metric",
    transform: "translate(237 2781.744)",
    fill: "#a7a9ac",
    fontSize: 9,
    fontFamily: "Roboto-Medium, Roboto",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -32.55,
    y: 0
  }, "METRIC")), /*#__PURE__*/React.createElement("text", {
    id: "RESULT",
    transform: "translate(342 2781.744)",
    fill: "#a7a9ac",
    fontSize: 9,
    fontFamily: "Roboto-Medium, Roboto",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -15.717,
    y: 0
  }, "RESULT")), /*#__PURE__*/React.createElement("text", {
    id: "November_2020",
    "data-name": "November 2020",
    transform: "translate(92 2746.744)",
    fill: "#329998",
    fontSize: 16,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "November 2020")), /*#__PURE__*/React.createElement("text", {
    id: "_11_03_2020",
    "data-name": "11/03/2020",
    transform: "translate(347 2742.744)",
    fill: "#329998",
    fontSize: 12,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "11/03/2020")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonthToDate);
export default __webpack_public_path__ + "static/media/monthToDate.5e549263.svg";
export { ForwardRef as ReactComponent };